import { createSelector } from 'reselect';
import { getLatestActivity } from './getLatestActivity';
import { getLatestNonIdleInterval } from './getLatestNonIdleInterval';

export const getTimeOptionsContext = createSelector(
  [getLatestActivity, getLatestNonIdleInterval],
  (latestActivity, latestNonIdleInterval) => {
    return {
      lastActivityStartAt: latestActivity?.start,
      lastActivityEndAt: latestActivity?.end,
      lastNonIdleStartAt: latestNonIdleInterval?.start,
      lastNonIdleEndAt: latestNonIdleInterval?.end,
    };
  }
);
